module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-home"
  }, [_c('div', {
    staticClass: "hide-for-small-only"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "chart-parameters"
  }, [_c('div', {
    staticClass: "row filter-form"
  }, [_c('div', {
    staticClass: "columns small-12 medium-3"
  }, [_c('date-range-picker', {
    on: {
      "input": _vm.dateRangeSelected
    },
    model: {
      value: (_vm.myRange),
      callback: function($$v) {
        _vm.myRange = $$v
      },
      expression: "myRange"
    }
  })], 1), _c('div', {
    staticClass: "columns small-12 medium-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bracketing),
      expression: "form.bracketing"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "bracketing", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("Monthly")]), _c('option', {
    attrs: {
      "value": "W"
    }
  }, [_vm._v("Weekly")]), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Daily")])])]), _c('div', {
    staticClass: "small-12 medium-3"
  }, [_c('loading-animation', {
    attrs: {
      "loading": _vm.formLoading
    }
  })], 1)])])])]), _c('div', {
    staticClass: "row dashboard-stats"
  }, [(_vm.$acl('charged-reservations-charts')) ? _c('div', {
    staticClass: "columns large-6"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('h2', [_vm._v("Charged reservations")]), (_vm.res) ? _c('line-chart', {
    attrs: {
      "data": _vm.res
    }
  }) : _vm._e()], 1)]) : _vm._e(), (_vm.$acl('driven-distance-charts')) ? _c('div', {
    staticClass: "columns large-6"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('h2', [_vm._v("Total mileage")]), (_vm.dis) ? _c('line-chart', {
    attrs: {
      "data": _vm.dis
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _c('div', {
    staticClass: "row dashboard-stats"
  }, [(_vm.$acl('driver-registrations-charts') && _vm.$acl('client-registrations-charts')) ? _c('div', {
    staticClass: "columns large-6"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('h2', [_vm._v("Registrations")]), (_vm.reg) ? _c('bar-chart', {
    attrs: {
      "data": _vm.reg
    }
  }) : _vm._e()], 1)]) : _vm._e(), (_vm.$acl('vehicle-reservations-charts') && _vm.$acl('vehicle-distance-charts')) ? _c('div', {
    staticClass: "columns large-6"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('h2', [_vm._v("Vehicle allocation")]), (_vm.vei) ? _c('bar-chart', {
    attrs: {
      "data": _vm.vei
    }
  }) : _vm._e()], 1)]) : _vm._e()]), (_vm.$acl('vehicles-by-zone-charts')) ? _c('div', {
    staticClass: "row dashboard-stats"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('h2', [_vm._v("Vehicles per zone")]), (this.loadingVeiByZ) ? _c('h3', [_vm._v("loading...")]) : _vm._e(), (_vm.veiByZ) ? _c('bar-chart', {
    attrs: {
      "data": _vm.veiByZ
    }
  }) : _vm._e()], 1)])]) : _vm._e()]), _c('home-controller')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56528a28!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/Home.vue
// module id = 2505
// module chunks = 1